// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BaseColumnLayout-wrapper-3vN77toOhz","item":"BaseColumnLayout-item-3XHqM9WpxD","col6":"BaseColumnLayout-col6-1X01Z1wvzB"};